/**
 * Раскрытый день «Графиков» (27.09, владелец: «при клике на первую колонку — дату и день
 * недели — разворачивалась расширенная строка данных: зелёные и красные столбики, внутри
 * красного — имена операторов, которые заняты в этот тайм-слот, внутри зелёного — свободные»).
 *
 * Строка во всю ширину сетки под днём; по часам — столбики: сверху красный (заняты), под ним
 * зелёный (свободны), имена в столбец. Колонка часа в сетке ~19px — имена туда не влезут,
 * поэтому у раскрытой строки свои колонки пошире и горизонтальная прокрутка.
 * Операторы — те же, что видны чипами (скрытые смахиванием не считаются), как у мега-сетки.
 */
import css from "./schedDay.module.css";

export interface SchedDay { key: string; dow: string; num: number }

export function SchedDayExpand({ day, hours, ops, stOf, onClose }: {
  day: SchedDay;
  hours: number[];
  ops: { id: string; name: string }[];
  /** Статус оператора в час: "free" | "busy" | прочее (не отметил). */
  stOf: (opId: string, dKey: string, h: number) => string;
  onClose: () => void;
}) {
  return (
    <div className={css.wrap}>
      <div className={css.head}>
        <span className={css.title}>{day.dow} {day.num} — кто занят и кто свободен</span>
        <button type="button" className={css.close} onClick={onClose} aria-label="Свернуть день">✕</button>
      </div>
      <div className={css.scroll}>
        {hours.map((h) => {
          const busy = ops.filter((o) => stOf(o.id, day.key, h) === "busy");
          const free = ops.filter((o) => stOf(o.id, day.key, h) === "free");
          return (
            <div key={h} className={`${css.col} ${h < 10 ? css.night : ""}`}>
              <div className={css.hour}>{String(h).padStart(2, "0")}:00</div>
              {busy.length ? (
                <div className={css.busy} title={`Заняты: ${busy.length}`}>
                  {busy.map((o) => <span key={o.id} className={css.name}>{o.name}</span>)}
                </div>
              ) : null}
              {free.length ? (
                <div className={css.free} title={`Свободны: ${free.length}`}>
                  {free.map((o) => <span key={o.id} className={css.name}>{o.name}</span>)}
                </div>
              ) : null}
              {!busy.length && !free.length ? <div className={css.none}>—</div> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
